import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { ref, computed, watch } from 'vue';

import dayjs from 'dayjs';
import { difference } from 'lodash';
import { queryLog } from '@/api/common';
import EDrawer from '@/components/bussiness/e-drawer/index.vue';

// -------------------------- 组件传参相关 --------------------------
interface LogDrawerProps {
  drawerVisible: boolean;
  bizNo: string;
  type: 'PROJECT' | 'USER' | 'ROLE' | 'GROUP' | 'RESOURCE' | 'SYSTEM';
  mianName: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LogDrawer',
  props: {
    drawerVisible: { type: Boolean },
    bizNo: {},
    type: {},
    mianName: {}
  },
  emits: ['update:drawerVisible'],
  setup(__props: any, { emit: __emit }) {

// 展示操作日志的抽屉
// 1. 需要外界传入 bizNo 以及 type 之后去请求接口。传入当条信息: itemInfo，判断主体
// "bizNo":"8",//业务ID 必需
// "type": "GROUP" //必需。PROJECT, USER, ROLE, GROUP, RESOURCE
// 2. 外界控制当前抽屉的展示与否。

const props = __props;

const emit = __emit;

// -------------------------- 组件内参数相关 --------------------------
const drawerShow = computed({
  get: () => props.drawerVisible,
  set: (val) => {
    console.log('val', val);
    emit('update:drawerVisible', val);
  }
});

// 表格内 loading 标志
const loading = ref<boolean>(false);

// 表格数据
const logList = ref<CommonDto.OperationLogDto[]>([]);

// -------------------------- 生命周期相关 --------------------------
// onMounted(() => {
//   requestLog();
// });

// -------------------------- 监听数据相关 --------------------------
watch(
  () => props.drawerVisible,
  () => {
    if (props.drawerVisible) {
      requestLog();
    }
  }
);

// -------------------------- 组件内事件相关 --------------------------
// 请求日志
const requestLog = () => {
  loading.value = true;
  const requestData: CommonRequest.queryLogRequest = {
    bizNo: props.bizNo,
    type: props.type
  };
  queryLog(requestData)
    .then((res) => {
      console.log(res);
      logList.value = res.data.logs;
    })
    .finally(() => {
      loading.value = false;
    });
};

// 格式化操作记录。

const formatLogData = (logData: CommonDto.LogDataDto[]) => {
  const { mianName } = props;
  const needHandleType = [
    'GROUP_BIND_USER',
    'GROUP_UNBIND_USER',
    'GROUP_BIND_ROLE',
    'ROLE_BIND_RESOURCE',
    'USER_BIND_ROLE'
  ];
  const logDataStringArr = logData.reduce<string[]>((acc, data) => {
    // 当 extendedType 为 GROUP_BIND_USER  GROUP_UNBIND_USER 一种处理方式
    // 为 GROUP_BIND_ROLE ROLE_BIND_RESOURCE USER_BIND_ROLE 为另一种处理方式
    // 这5种type的 newValue 与 oldValue 均为数组JSON， 其他情况为普通字符串
    // 服务端文档 - 操作日志 https://b9nhtlfpd3.feishu.cn/docx/RZnvdg0Eto9yJjxndItc9B48n6g
    const { extendedType } = data;

    if (needHandleType.includes(extendedType)) {
      return acc.concat(formatBindType(data));
    }

    const { name, newValue } = data;
    return acc.concat(`${mianName} ${name} ${newValue}`);
  }, []);
  return logDataStringArr;
};

const formatBindType = (logData: CommonDto.LogDataDto) => {
  const { mianName } = props;
  const { extendedType, oldValue, newValue, name } = logData;
  let parseOldValue = [];
  let parseNewValue = [];
  try {
    parseOldValue = JSON.parse(oldValue);
  } catch (e) {
    console.error('logData中的oldValue解析失败', logData);
  }
  try {
    parseNewValue = JSON.parse(newValue);
  } catch (e) {
    console.error('logData中的newValue解析失败', logData);
  }

  const needDiffType = ['GROUP_BIND_ROLE', 'ROLE_BIND_RESOURCE', 'USER_BIND_ROLE'];

  if (needDiffType.includes(extendedType)) {
    // 新数据中有的, 旧数据中没有的，为绑定XX
    // 新数据中没有有的, 旧数据中有的，为解绑XX
    const diffValueArr = [];
    const addValue = difference(parseNewValue, parseOldValue).join(',');
    const delValue = difference(parseOldValue, parseNewValue).join(',');
    // 当diff结果不为空的时候，将处理结果放入数组种。
    if (addValue !== '') {
      diffValueArr.push(`${mianName} ${name} ${addValue}`);
    }
    if (delValue !== '') {
      diffValueArr.push(`${mianName} 解绑${name} ${delValue}`);
    }
    return diffValueArr;
  }

  return [`${mianName} ${name} ${parseNewValue.join(',')}`];
};

return (_ctx: any,_cache: any) => {
  const _component_e_table_column = _resolveComponent("e-table-column")!
  const _component_e_table = _resolveComponent("e-table")!
  const _component_e_button = _resolveComponent("e-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(EDrawer, {
      modelValue: drawerShow.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawerShow).value = $event)),
      title: "操作日志",
      size: "40%"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_e_button, {
          type: "main",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (drawerShow.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_e_table, {
          border: "",
          data: logList.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_e_table_column, {
              label: "时间",
              prop: "createTime",
              width: "120px"
            }, {
              default: _withCtx((scoped) => [
                _createTextVNode(_toDisplayString(_unref(dayjs)(scoped.row.createTime).format('YYYY-MM-DD HH:mm:ss')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_e_table_column, {
              label: "操作",
              prop: "logData",
              "min-width": "50px"
            }, {
              default: _withCtx((scoped) => [
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formatLogData(scoped.row.logData), (item) => {
                    return (_openBlock(), _createElementBlock("div", { key: item }, _toDisplayString(item), 1))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_e_table_column, {
              label: "操作人",
              prop: "operatorName",
              width: "80px"
            }, {
              default: _withCtx((scoped) => [
                _createTextVNode(_toDisplayString(scoped.row.operatorName), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, loading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})